/* Diamond Domain - product option stack (Sep 2026).

   Rings are asked for in the order a jeweller asks:

     YOUR DIAMOND   Shape, Carat, Diamond Quality
     YOUR SETTING   Metal
     YOUR FIT       Ring size (size guide on the same line), Service plan

   The catalogue is NOT uniform. Pendants, necklaces, earrings, studs and eternity bands carry
   Metal and nothing else, so headings are only written when a group has a visible member AND
   there is another group to tell it apart from - otherwise those pages showed "YOUR DIAMOND"
   above empty space, or "METAL" directly above a fieldset already labelled METAL.

   The guard flag lives on <variant-selects>, NOT on .product__form__wrapper. Choosing a metal
   makes the theme replace <variant-selects> wholesale while the wrapper survives; a flag on
   the wrapper made run() return early and the page silently reverted to the theme's own
   layout, losing the group headings and every metal name. dd-pdp.js drives the re-run.

   Quantity is removed. Nobody buys two engagement rings; it was pure friction.
   Single-value options are removed too - most rings carry Shape as an option with exactly one
   value, which renders as a lone dead button you cannot choose anything else with.

   <variant-selects> is a CSS grid and the theme sets `order: -1` on the metal wrapper, so
   metal floats to the top wherever it sits in the markup. Hence the explicit `order` values
   below, and grid-column: 1 / -1 in the stylesheet.

   Delete this file and its line in layout/theme.liquid to revert. */
(function () {
  function legendOf(fs) {
    return fs.querySelector('legend .radio__legend__label') ||
           fs.querySelector('.radio__legend__label') ||
           fs.querySelector('legend');
  }

  function tidy(s) {
    return s.replace(/\s+/g, ' ').trim();
  }

  function labelText(fs) {
    var l = legendOf(fs);
    return l ? tidy(l.textContent) : '';
  }

  function findFieldset(scope, re) {
    var all = scope.querySelectorAll('fieldset.radio__fieldset');
    for (var i = 0; i < all.length; i++) {
      if (re.test(labelText(all[i]))) return all[i];
    }
    return null;
  }

  function wrapOf(fs) {
    return fs ? (fs.closest('.selector-wrapper') || fs) : null;
  }

  /* an element counts towards its group only if it is really going to be seen */
  function shown(el) {
    return !!el && el.style.display !== 'none' && !el.hidden;
  }

  function groupLabel(text) {
    var d = document.createElement('div');
    d.className = 'dd-group-label';
    d.textContent = text;
    return d;
  }

  function setOrder(el, n) {
    if (el) el.style.order = String(n);
  }

  function reflectValue(fs) {
    var legend = legendOf(fs);
    if (!legend) return;

    if (!legend.dataset.ddBase) {
      legend.dataset.ddBase = tidy(legend.textContent);
    }
    var base = legend.dataset.ddBase;

    var span = legend.querySelector('.dd-chosen');
    if (!span) {
      span = document.createElement('span');
      span.className = 'dd-chosen';
      legend.appendChild(span);
    }

    function update() {
      var checked = fs.querySelector('input[type=radio]:checked');
      var val = '';
      if (checked) {
        var lab = fs.querySelector('label[for="' + checked.id + '"]');
        val = tidy(checked.value || (lab ? lab.textContent : ''));
      }
      if (legend.childNodes[0] && legend.childNodes[0].nodeType === 3) {
        legend.childNodes[0].nodeValue = base;
      }
      span.textContent = val;
    }

    fs.addEventListener('change', update);
    update();
  }

  /* Seven metal options rendered as circles of the shop's own swatch art with the karat baked
     into the picture - three of them reading "14 K" and differing only by tint. The real name
     was already in the markup as visually-hidden text for screen readers; this puts it on
     screen, and tags each label so dd-metals.css can draw that metal's art as a round chip. */
  function labelMetals(fs) {
    fs.classList.add('dd-metal');
    var wrap = wrapOf(fs);
    if (wrap) wrap.classList.add('dd-metal');

    fs.querySelectorAll('label.swatch__label').forEach(function (label) {
      if (label.querySelector('.dd-metal__name')) return;
      var hidden = label.querySelector('.visually-hidden');
      if (!hidden) return;

      var full = tidy(hidden.textContent);          /* "14K Yellow Gold" */
      var name = full.replace(/\s+Gold$/i, '');     /* "14K Yellow" */

      label.setAttribute('data-dd-metal', name.toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, ''));                    /* "14k-yellow" */

      var span = document.createElement('span');
      span.className = 'dd-metal__name';
      span.setAttribute('aria-hidden', 'true');     /* the hidden span still names it for AT */
      span.textContent = name;
      label.appendChild(span);
    });
  }

  /* The size guide belongs beside the size field, not at the top of the page. The whole
     .product__form__size-chart div is MOVED (not cloned) so its <drawer-toggle> and the
     aria-controls link to the drawer keep working. This half of the form survives a variant
     re-render, so it must not be built twice. */
  function placeSizeGuide(form) {
    if (form.querySelector('.dd-option__head')) return;

    var chart = form.querySelector('.product__form__size-chart');
    if (!chart) return;

    var select = form.querySelector('select[name="properties[Ring Size]"]');
    if (!select) {
      /* no size to guide - at least let it fall below the options instead of above them */
      setOrder(chart, 9);
      return;
    }

    var option = select.closest('.dd-option');
    var label = option ? option.querySelector('.dd-option__label') : null;
    if (!option || !label) { setOrder(chart, 9); return; }

    var head = document.createElement('div');
    head.className = 'dd-option__head';
    option.insertBefore(head, label);
    head.appendChild(label);
    head.appendChild(chart);
  }

  function run() {
    var form = document.querySelector('.product__form__wrapper');
    if (!form) return false;

    var selects = form.querySelector('variant-selects.product__selectors') ||
                  form.querySelector('variant-selects');
    if (!selects) return false;

    /* the flag rides the element the theme actually replaces */
    if (selects.dataset.ddStack === '1') return true;

    var metalFs = findFieldset(selects, /^metal/i);
    var caratFs = findFieldset(selects, /carat/i);
    var shapeFs = findFieldset(selects, /^shape/i);
    var qualityFs = findFieldset(selects, /quality/i);
    if (!metalFs && !caratFs) return false;

    /* a choice of one is not a choice */
    selects.querySelectorAll('fieldset.radio__fieldset').forEach(function (fs) {
      if (fs.querySelectorAll('input[type=radio]').length <= 1) {
        var w = wrapOf(fs);
        w.style.display = 'none';
        w.setAttribute('data-dd-hidden-single-option', 'true');
      }
    });

    var metalWrap = wrapOf(metalFs);
    var caratWrap = wrapOf(caratFs);
    var shapeWrap = wrapOf(shapeFs);
    var qualityWrap = wrapOf(qualityFs);

    var shape = document.getElementById('dd-shape-siblings');
    if (shape) selects.appendChild(shape);

    /* Only head a group that has something in it, and only when there is more than one group
       to tell apart. A pendant has Metal and nothing else; it needs no headings at all. */
    var hasDiamond = shown(shape) || shown(shapeWrap) || shown(caratWrap) || shown(qualityWrap);
    var hasSetting = shown(metalWrap);

    if (hasDiamond && hasSetting) {
      var diamondHead = groupLabel('Your diamond');
      var settingHead = groupLabel('Your setting');
      selects.appendChild(diamondHead);
      selects.appendChild(settingHead);
      setOrder(diamondHead, 1);
      setOrder(settingHead, 6);
    }

    setOrder(shape, 2);
    setOrder(shapeWrap, 3);   /* only visible when a ring really offers several shapes */
    setOrder(caratWrap, 4);
    setOrder(qualityWrap, 5); /* two necklaces carry Diamond Quality as a real option */
    setOrder(metalWrap, 7);

    var qty = form.querySelector('.selector-wrapper--qty');
    if (qty) qty.style.display = 'none';

    /* "Your fit" only where there is something to fit */
    var opts = form.querySelector('.dd-options');
    if (opts && opts.querySelector('.dd-option') && !opts.querySelector('.dd-group-label') &&
        hasDiamond && hasSetting) {
      opts.insertBefore(groupLabel('Your fit'), opts.firstChild);
    }

    placeSizeGuide(form);

    if (metalFs) { labelMetals(metalFs); reflectValue(metalFs); }
    if (caratFs) reflectValue(caratFs);
    if (qualityFs && qualityFs.querySelectorAll('input[type=radio]').length > 1) reflectValue(qualityFs);
    if (shapeFs && shapeFs.querySelectorAll('input[type=radio]').length > 1) reflectValue(shapeFs);

    selects.dataset.ddStack = '1';
    return true;
  }

  (window.__ddInit = window.__ddInit || []).push(run);

  function start() {
    if (run()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (run() || ++tries > 24) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();